export default function dollar(amount) {
  return Math.floor(parseInt(amount, 10) / 100);
}